import { call, put, fork, takeEvery } from 'redux-saga/effects'
import { convertRawGrant } from 'types/grants'
import axios, { axiosAccounts } from 'utils/axios'
import { getErrorMessage, joinAll } from 'utils/api'
// Local deps
import GrantsActions, { GrantsTypes } from './actions'

// Sagas
function * checkGrants ({ grants, key, field }) {
  yield put(GrantsActions.checkGrantsLoading(key))
  try {
    const tasks = []
    for (const grant of grants) {
      const { userId, grantType, context } = grant
      const body = { type_grant: { id: grantType }, context }
      const url = `/grant/check/${userId}`
      tasks.push(yield fork(axios.post, url, body))
    }
    const joinedResults = yield joinAll(tasks)
    const resultGrants = joinedResults.reduce((allResults, { data: { data } }, index) => ([
      ...allResults,
      {
        grant: grants[index],
        allowed: data.allowed,
      },
    ]), [])
    yield put(GrantsActions.checkGrantsSuccess(resultGrants, key))
  } catch (e) {
    yield put(GrantsActions.checkGrantsFailure(key, getErrorMessage(e)))
  }
}

function * checkGrant ({ grant, key, field, resultField }) {
  yield put(GrantsActions.checkGrantLoading(grant, key))
  try {
    const { userId, grantType, context } = grant
    const body = { type_grant: { id: grantType }, context }
    const url = `/grant/check/${userId}`

    const { data: { data } } = yield call(axios.post, url, body)
    if (field) {
      yield put(GrantsActions.checkGrantsLoading(key))
      const { [field]: allowed } = data
      const grants = Object.keys(allowed).map(key => ({
        grant: {
          userId,
          grantType,
          context: {
            [resultField]: key,
          },
        },
        allowed: allowed[key],
      }))
      yield put(GrantsActions.checkGrantsSuccess(grants, key))
      yield put(GrantsActions.checkGrantSuccess(grant, true, key))
    }
    if (!field) yield put(GrantsActions.checkGrantSuccess(grant, data.allowed, key))
  } catch (e) {
    yield put(GrantsActions.checkGrantFailure(getErrorMessage(e), key))
  }
}
// Retrieve a list of grants for user
function * getGrants ({ userId }) {
  yield put(GrantsActions.getGrantsLoading())
  try {
    const url = `/grant/${userId}`
    const { data: { data } } = yield call(axiosAccounts.get, url)
    const grants = data.grants.map(convertRawGrant)
    const navlabUsed = data.navlab_used
    const navlabMax = data.navlab_max
    yield put(GrantsActions.getGrantsSuccess(grants, navlabUsed, navlabMax, userId))
  } catch (e) {
    yield put(GrantsActions.getGrantsFailure(getErrorMessage(e)))
  }
}
// Watchers
function * checkGrantWatcher () {
  yield takeEvery(GrantsTypes.CHECK_GRANT, checkGrant)
}

function * checkGrantsWatcher () {
  yield takeEvery(GrantsTypes.CHECK_GRANTS, checkGrants)
}

function * getGrantsWatcher () {
  yield takeEvery(GrantsTypes.GET_GRANTS, getGrants)
}

export default function * root () {
  yield fork(checkGrantWatcher)
  yield fork(checkGrantsWatcher)
  yield fork(getGrantsWatcher)
}
